/*
 * E-letter archive.
 *
 * Years are rendered by sections/newsletter-archive.liquid straight from the blog's
 * tags. This file only fills each year in on demand from
 * /blogs/<blog>/tagged/<year>?view=archive-json (templates/blog.archive-json.liquid),
 * so nothing on the page has to be maintained by hand as new e-letters are imported.
 */
(function () {
  'use strict';

  var CACHE_PREFIX = 'nl-archive:';

  function text(el, value) {
    el.textContent = value == null ? '' : String(value);
  }

  /* Mirrors snippets/newsletter-archive-card.liquid. */
  function buildCard(item, options) {
    var li = document.createElement('li');
    li.className = 'nl-card';
    li.setAttribute('data-nl-card', '');
    // Mirrors the haystack in snippets/newsletter-archive-card.liquid.
    li.setAttribute(
      'data-nl-haystack',
      [item.title, item.excerpt, item.month, item.year].filter(Boolean).join(' ').toLowerCase()
    );

    var link = document.createElement('a');
    link.className = 'nl-card__link';
    link.href = item.url;

    if (options.showImage) {
      var media = document.createElement('span');
      media.className = 'nl-card__media __crop-' + options.cropShape;

      if (item.image) {
        var img = document.createElement('img');
        img.className = 'nl-card__img';
        img.src = item.image;
        img.alt = item.image_alt || item.title || '';
        img.width = 320;
        img.height = 200;
        img.loading = 'lazy';
        media.appendChild(img);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'nl-card__img nl-card__img--placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        text(placeholder, (item.month || '').slice(0, 3));
        media.appendChild(placeholder);
      }

      link.appendChild(media);
    }

    var body = document.createElement('span');
    body.className = 'nl-card__body';

    var date = document.createElement('span');
    date.className = 'nl-card__date p-sm';
    text(date, item.date_label);
    body.appendChild(date);

    var title = document.createElement('span');
    title.className = 'nl-card__title h6';
    text(title, item.title);
    body.appendChild(title);

    if (options.showExcerpt && item.excerpt) {
      var excerpt = document.createElement('span');
      excerpt.className = 'nl-card__excerpt p-sm';
      text(excerpt, item.excerpt);
      body.appendChild(excerpt);
    }

    link.appendChild(body);
    li.appendChild(link);
    return li;
  }

  function Archive(root) {
    this.root = root;
    this.feedTemplate = root.getAttribute('data-feed-url') || '';
    this.status = root.querySelector('[data-nl-status]');
    this.noResults = root.querySelector('[data-nl-no-results]');
    this.searchInput = root.querySelector('[data-nl-search]');
    this.years = Array.prototype.slice.call(root.querySelectorAll('[data-nl-year]'));
    this.loaded = {};
    this.loading = {};
    this.options = {
      showImage: root.querySelector('.nl-card__media') !== null || !root.querySelector('[data-nl-prerendered]'),
      showExcerpt: true,
      cropShape: 'rounded'
    };

    var prerenderedCard = root.querySelector('[data-nl-prerendered] .nl-card');
    if (prerenderedCard) {
      var media = prerenderedCard.querySelector('.nl-card__media');
      this.options.showImage = media !== null;
      this.options.showExcerpt = prerenderedCard.querySelector('.nl-card__excerpt') !== null;
      if (media) {
        var crop = /__crop-([\w-]+)/.exec(media.className);
        if (crop) this.options.cropShape = crop[1];
      }
    }

    this.bind();
    this.init();
    this.trackBar();
  }

  /* Mirrors the site header's show-on-scroll-up behaviour on the sticky bar. */
  Archive.prototype.trackBar = function () {
    var bar = this.root.querySelector('.nl-archive__bar');
    if (!bar) return;

    var ticking = false;
    var update = function () {
      ticking = false;
      var header = document.querySelector('sticky-header');
      bar.classList.toggle('is-nav-hidden', !(header && header.classList.contains('__visible')));
    };

    var onScroll = function () {
      if (!bar.isConnected) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      // Next frame, so the header's own scroll handler has already toggled __visible.
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  };

  Archive.prototype.feedUrl = function (year, page) {
    var url = this.feedTemplate.replace('TAG', encodeURIComponent(year));
    return page > 1 ? url + '&page=' + page : url;
  };

  Archive.prototype.section = function (year) {
    for (var i = 0; i < this.years.length; i++) {
      if (this.years[i].getAttribute('data-nl-year') === year) return this.years[i];
    }
    return null;
  };

  Archive.prototype.init = function () {
    var self = this;

    this.years.forEach(function (section) {
      var year = section.getAttribute('data-nl-year');
      if (section.hasAttribute('data-nl-prerendered')) {
        self.loaded[year] = true;
        self.updateCount(section);
      }
    });

    // Deep link: /pages/archived-e-letters#nl-year-2019 opens that year.
    var hash = window.location.hash.replace('#', '');
    if (hash.indexOf('nl-year-') === 0) {
      var target = hash.replace('nl-year-', '');
      this.open(target, true);
    }
  };

  Archive.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-nl-toggle]');
      if (toggle) {
        var section = toggle.closest('[data-nl-year]');
        var year = section.getAttribute('data-nl-year');
        if (section.classList.contains('is-open')) self.close(year);
        else self.open(year);
        return;
      }

      var chip = event.target.closest('[data-nl-year-link]');
      if (chip) {
        event.preventDefault();
        self.open(chip.getAttribute('data-nl-year-link'), true);
      }
    });

    if (this.searchInput) {
      var timer = null;
      this.searchInput.addEventListener('input', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          self.search(self.searchInput.value.trim().toLowerCase());
        }, 180);
      });
    }
  };

  Archive.prototype.open = function (year, scrollIntoView) {
    var self = this;
    var section = this.section(year);
    if (!section) return;

    // One year at a time. Search is exempt: filter() opens every year holding a
    // match, because results have to be visible across all of them at once.
    this.years.forEach(function (other) {
      var otherYear = other.getAttribute('data-nl-year');
      if (otherYear !== year) self.close(otherYear);
    });

    var panel = section.querySelector('.nl-year__panel');
    var toggle = section.querySelector('[data-nl-toggle]');
    section.classList.add('is-open');
    panel.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    this.markCurrent(year);
    this.load(year);

    if (scrollIntoView) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  Archive.prototype.close = function (year) {
    var section = this.section(year);
    if (!section) return;
    var panel = section.querySelector('.nl-year__panel');
    var toggle = section.querySelector('[data-nl-toggle]');
    section.classList.remove('is-open');
    panel.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  };

  Archive.prototype.markCurrent = function (year) {
    var chips = this.root.querySelectorAll('[data-nl-year-link]');
    for (var i = 0; i < chips.length; i++) {
      chips[i].classList.toggle('is-current', chips[i].getAttribute('data-nl-year-link') === year);
    }
  };

  Archive.prototype.updateCount = function (section) {
    var counter = section.querySelector('[data-nl-count]');
    if (!counter) return;
    var total = section.querySelectorAll('[data-nl-card]').length;
    text(counter, total === 1 ? '1 e-letter' : total + ' e-letters');
  };

  Archive.prototype.cached = function (year) {
    try {
      var raw = window.sessionStorage.getItem(CACHE_PREFIX + this.feedUrl(year, 1));
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  };

  Archive.prototype.cache = function (year, items) {
    try {
      window.sessionStorage.setItem(CACHE_PREFIX + this.feedUrl(year, 1), JSON.stringify(items));
    } catch (error) {
      /* Private browsing or a full quota - the archive still works, just uncached. */
    }
  };

  Archive.prototype.load = function (year) {
    var self = this;
    if (this.loaded[year]) return Promise.resolve();
    if (this.loading[year]) return this.loading[year];

    var section = this.section(year);
    if (!section) return Promise.resolve();

    var list = section.querySelector('[data-nl-list]');
    var spinner = section.querySelector('[data-nl-loading]');

    var cached = this.cached(year);
    if (cached) {
      this.render(section, list, cached);
      this.loaded[year] = true;
      return Promise.resolve();
    }

    if (spinner) spinner.hidden = false;

    // Follow next_page in case a single year ever exceeds the 50-article page size.
    var collected = [];
    var fetchPage = function (page) {
      return fetch(self.feedUrl(year, page), { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function (data) {
          collected = collected.concat(data.articles || []);
          if (data.next_page) return fetchPage(data.next_page);
          return collected;
        });
    };

    this.loading[year] = fetchPage(1)
      .then(function (items) {
        self.render(section, list, items);
        self.cache(year, items);
        self.loaded[year] = true;
      })
      .catch(function () {
        if (self.status) {
          text(self.status, 'Could not load ' + year + '. Please refresh and try again.');
        }
        // Retries must not stack up another copy of the link each time.
        if (!section.querySelector('.nl-year__fallback--error')) {
          var fallback = document.createElement('a');
          fallback.className = 'nl-year__fallback nl-year__fallback--error';
          fallback.href = self.root.getAttribute('data-blog-url') + '/tagged/' + year;
          text(fallback, 'View ' + year + ' e-letters');
          list.parentNode.appendChild(fallback);
        }
      })
      .then(function () {
        if (spinner) spinner.hidden = true;
        delete self.loading[year];
      });

    return this.loading[year];
  };

  Archive.prototype.render = function (section, list, items) {
    var self = this;
    var fragment = document.createDocumentFragment();
    items.forEach(function (item) {
      fragment.appendChild(buildCard(item, self.options));
    });
    list.appendChild(fragment);
    this.updateCount(section);

    var term = this.searchInput && this.searchInput.value.trim().toLowerCase();
    if (term) this.filter(term);
  };

  /* Searching spans every year, so pull in the ones not loaded yet. */
  Archive.prototype.search = function (term) {
    var self = this;

    if (!term) {
      this.years.forEach(function (section) {
        section.hidden = false;
        var cards = section.querySelectorAll('[data-nl-card]');
        for (var i = 0; i < cards.length; i++) cards[i].hidden = false;
        if (!section.hasAttribute('data-nl-prerendered')) self.close(section.getAttribute('data-nl-year'));
      });
      if (this.noResults) this.noResults.hidden = true;
      if (this.status) text(this.status, '');
      return;
    }

    // Show what we can immediately; each year re-filters itself as it arrives
    // (render() calls filter), so results fill in rather than blocking on all of them.
    this.filter(term);

    var pending = this.years
      .map(function (section) { return section.getAttribute('data-nl-year'); })
      .filter(function (year) { return !self.loaded[year]; });

    if (!pending.length) return;

    this.searching = term;
    if (this.status) text(this.status, 'Searching earlier years…');

    Promise.all(pending.map(function (year) { return self.load(year); })).then(function () {
      // Ignore a batch the visitor has already typed past.
      if (self.searching !== term) return;
      self.searching = null;
      self.filter(term);
    });
  };

  Archive.prototype.filter = function (term) {
    var matches = 0;

    this.years.forEach(function (section) {
      var cards = section.querySelectorAll('[data-nl-card]');
      var visible = 0;

      for (var i = 0; i < cards.length; i++) {
        var hit = (cards[i].getAttribute('data-nl-haystack') || '').indexOf(term) !== -1;
        cards[i].hidden = !hit;
        if (hit) visible += 1;
      }

      section.hidden = visible === 0;
      if (visible > 0) {
        section.classList.add('is-open');
        section.querySelector('.nl-year__panel').hidden = false;
        var toggle = section.querySelector('[data-nl-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
      matches += visible;
    });

    var stillLoading = Boolean(this.searching);
    if (this.noResults) this.noResults.hidden = matches > 0 || stillLoading;
    if (this.status) {
      var label = matches === 1 ? '1 match' : matches + ' matches';
      text(this.status, stillLoading ? label + ' so far, searching earlier years…' : (matches === 0 ? '' : label));
    }
  };

  function start() {
    var roots = document.querySelectorAll('[data-newsletter-archive]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].dataset.nlReady) {
        roots[i].dataset.nlReady = 'true';
        new Archive(roots[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Theme editor re-renders the section without a page load. */
  document.addEventListener('shopify:section:load', start);
})();
